export const DOMAIN_REPORTS = "REPORTS";
